import React from 'react';
import { useTranslation } from 'react-i18next';

interface MigrationProgressData {
  current: number;
  total: number;
  migrated: number;
  failed: number;
  skipped: number;
  currentFile: string;
}

interface MigrationProgressProps {
  progress: MigrationProgressData;
}

export default function MigrationProgress({ progress }: MigrationProgressProps) {
  const { t } = useTranslation();
  const percentage =
    progress.total > 0 ? Math.round((progress.current / progress.total) * 100) : 0;

  return (
    <div className="rounded-lg border border-border bg-card">
      <div className="border-b border-border px-6 py-4">
        <h3 className="text-lg font-semibold text-foreground">{t('Migration Progress')}</h3>
      </div>
      <div className="p-6 flex flex-col gap-3">
        {/* Progress bar header */}
        <div className="flex items-center justify-between text-sm text-muted-foreground">
          <span>
            {t('Migrating')} {progress.current} / {progress.total} {t('files')}...
          </span>
          <span>{percentage}%</span>
        </div>

        {/* TODO(batch5): Replace with shared LinearProgress component */}
        <div className="h-2.5 w-full rounded-full bg-muted overflow-hidden">
          <div
            className="h-full rounded-full bg-primary transition-all duration-300"
            style={{ width: `${percentage}%` }}
          />
        </div>

        {progress.currentFile && (
          <p className="text-xs text-muted-foreground">
            {t('Current file')}: {progress.currentFile}
          </p>
        )}

        <div className="flex gap-4 mt-1">
          <span className="text-sm text-success">{t('Migrated')}: {progress.migrated}</span>
          <span className="text-sm text-destructive">{t('Failed')}: {progress.failed}</span>
          <span className="text-sm text-muted-foreground">{t('Skipped')}: {progress.skipped}</span>
        </div>
      </div>
    </div>
  );
}
